<template>
  <div role="tablist">
    <template v-for="(group, index) in getControlPanelStatusActorsGroups(service.id)">
      <template v-if="group === ''">
        <template
          v-for="actor in getActorsForServiceAndGroup(service.id, group)"
        >
          <status v-if="actor.control_group === 'status'" :key="`s-${actor.id}`" :actor="actor" show-title class="mb-2" />
          <control-actor v-else-if="actor.control_group === 'control'" :key="`cac-${actor.id}`" show-label :actor="actor" class="mb-2" />
          <hr :key="`h-${actor.id}`" />
        </template>
      </template>
      <template v-else>
        <b-button
          :key="`a-button-${index}`"
          block
          href="#"
          v-b-toggle="`a-actor-${index}`"
          variant="secondary"
          class="my-1"
        >
          {{ group }}
        </b-button>
        <b-collapse
          :key="`a-collapse-${index}`"
          :id="`a-actor-${index}`"
          accordion="settings"
          role="tabpanel"
          class="py-3"
        >
          <template
            v-for="actor in getActorsForServiceAndGroup(service.id, group)"
          >
            <status v-if="actor.control_group === 'status'" :key="`s-${actor.id}`" :actor="actor" show-title class="mb-2" />
            <control-actor v-else-if="actor.control_group === 'control'" :key="`s-${actor.id}`" show-label :actor="actor" class="mb-2" />
            <hr :key="`h-${actor.id}`" />
          </template>
        </b-collapse>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Status from '@/components/services/service/control-panel/Status.vue';
import ControlActor from "@/components/services/service/ControlActor";

export default {
  name: 'StatusControlActors',
  props: {
    service: {
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'getControlPanelStatusActorsGroups',
      'getActorsForServiceAndGroup',
    ]),
  },
  components: {
    ControlActor,
    Status,
  },
};
</script>

<style scoped>

</style>
